<template>
    <button :disabled="loading" v-html="btnLabel" class="btn btn-danger btn-xs" @click="confirmDeleteCarrierDestination">
    </button>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "CarrierDestinationDeleteButton",
    props: {
        carrierDestination: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        confirmDeleteCarrierDestination() {
            Swal.fire({
                title: this.$t("CarrierDestinationDeleteButton.youSureToDelete"),
                text: this.$t("CarrierDestinationDeleteButton.youCantUndo"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("CarrierDestinationDeleteButton.delete"),
                cancelButtonText: this.$t("CarrierDestinationDeleteButton.cancel"),
            }).then(result => {
                if (result.value) {
                    this.deleteCarrierDestination();
                }
            });
        },
        async deleteCarrierDestination() {
            try {
                this.loading = true;
                await this.$diceAPI.deleteCarrierDestination(this.carrierDestination);
                this.$emit("deleteCarrierDestination", this.carrierDestination);
                this.$toasted.success(this.$t("CarrierDestinationDeleteButton.carrierDestinationDeleted"), { icon: "check" });
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
    },
    computed: {
        btnLabel() {
            return this.loading ? "<i class='fa fa-spin fa-spinner'></i>" : "<i class='fa fa-times'></i>";
        },
    },
};
</script>

<style scoped>

</style>